// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJEcWoX_bkMv0s2yCTgkSFBv-EEGT_2Is",
  authDomain: "tejcodex-4237d.firebaseapp.com",
  projectId: "tejcodex-4237d",
  storageBucket: "tejcodex-4237d.firebasestorage.app",
  messagingSenderId: "1078003614912",
  appId: "1:1078003614912:web:f25d73d10870ac81985925",
  measurementId: "G-PBH2CTDPPD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // ✅ Authentication instance
export const analytics = getAnalytics(app);
